// updated along with app/lib/enums/taxonomy_level.py
const taxonomyColumns = {
  l4_category_name: 'l4_category_name',
  l3_category_name: 'l3_category_name',
  l2_category_name: 'l2_category_name',
  l1_category_name: 'l1_category_name',
  l0_category_name: 'l0_category_name',
  l4_rosetta_category_id: 'l4_rosetta_category_id',
  l3_rosetta_category_id: 'l3_rosetta_category_id',
  l2_rosetta_category_id: 'l2_rosetta_category_id',
  l1_rosetta_category_id: 'l1_rosetta_category_id',
  l0_rosetta_category_id: 'l0_rosetta_category_id',
  l4_category_display_name: 'l4_category_display_name',
  l3_category_display_name: 'l3_category_display_name',
  l2_category_display_name: 'l2_category_display_name',
  l1_category_display_name: 'l1_category_display_name',
  l0_category_display_name: 'l0_category_display_name',
};

const TaxonomyLevel = {
  L0: '0',
  L1: '1',
  L2: '2',
  L3: '3',
  L4: '4',
};

const TaxonomyGlobal = {
  GL: 'GL',
};

const CATEGORY_OPTIONS = [
  { value: TaxonomyGlobal.GL, label: 'Global' },
  { value: TaxonomyLevel.L0, label: 'L0 Category' },
  { value: TaxonomyLevel.L1, label: 'L1 Category' },
  { value: TaxonomyLevel.L2, label: 'L2 Category' },
  { value: TaxonomyLevel.L3, label: 'L3 Category' },
  { value: TaxonomyLevel.L4, label: 'L4 Category' },
];

const l0AdministrativeCategoryId = 1;
const l0BeverageCategoryId = 2;
const l0FoodCategoryId = 3;
const l0OperationalsCategoryId = 4;

export {
  CATEGORY_OPTIONS,
  taxonomyColumns,
  TaxonomyGlobal,
  l0AdministrativeCategoryId,
  l0BeverageCategoryId,
  l0FoodCategoryId,
  l0OperationalsCategoryId,
};
export default TaxonomyLevel;
